import React from "react";
import { TouchableOpacity, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
// import useTimeTracking from "../../hooks/TimeTracking/useTimeTracking";
import { useTracking } from "../../context/TimeTracking/TimeTrackingContext";

const FloatingButton: React.FC = () => {
  const {
    clockInTime,
    clockOutTime,
    isOnBreak,
    isOnLunch,
    handleClockIn,
    handleClockOut,
  } = useTracking();

  const isTracking = !!clockInTime && !clockOutTime && !isOnBreak && !isOnLunch;

  const handleToggle = () => {
    const taskNote = JSON.stringify({ task1: "Clocked via floating button" });

    if (isOnBreak || isOnLunch || clockOutTime) {
      handleClockIn(taskNote);
    } else if (isTracking) {
      handleClockOut(taskNote);
    } else {
      handleClockIn(taskNote);
    }
  };

  const iconName = isOnBreak || isOnLunch || clockOutTime
    ? "play-circle-outline"
    : isTracking
    ? "pause-circle-outline"
    : "clock-outline";

  return (
    <TouchableOpacity
      style={styles.floatingButton}
      onPress={handleToggle}
      activeOpacity={0.85}
    >
      <MaterialCommunityIcons name={iconName} size={32} color="#fff" />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  floatingButton: {
    backgroundColor: "#8DB628",
    width: 70,
    height: 70,
    borderRadius: 35,
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    alignSelf: "center",
    transform: [{ translateY: -45 }],
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.3,
    shadowRadius: 6,
    elevation: 8,
    zIndex: 100,
  },
});

export default FloatingButton;